module.exports = ".error-page {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-page/error-page.component.scss
// module id = ./src/app/components/error-page/error-page.component.scss
// module chunks = main